import Image from '@atoms/Image/Image';
import LoadMoreButton from '@atoms/LoadMoreButton/LoadMoreButton';
import type { IImage } from '@models/IImage';
import CollapsibleTextSection from '@molecules/CollapsibleTextSection/CollapsibleTextSection';
import SoftLoadWrapper from '@molecules/SoftLoadWrapper/SoftLoadWrapper';
import { useState } from 'react';

interface Props {
  readonly anchorId?: string;
  readonly bioLogo: IImage;
  readonly loadLessLabel: string;
  readonly loadMoreLabel: string;
  readonly subText?: string;
  readonly title: string;
}

const AuthorBiography = ({
  anchorId = '',
  bioLogo,
  loadLessLabel,
  loadMoreLabel,
  subText,
  title,
}: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <section
      id={`a-${anchorId}`}
      className="component-padding bg-white text-black-100 dark:bg-black-100 dark:text-white"
      data-testid="CT-80-Author-Biography"
    >
      <SoftLoadWrapper>
        <div className="container grid gap-y-5 xl:grid-cols-12 xl:gap-y-15">
          <Image
            image={bioLogo}
            classes="xl:col-span-2 xl:col-start-2"
            imageClasses="min-w-[150px]"
            dataTestId="CT-80-Author-Biography"
          />
          {title && (
            <div className="col-span-full xl:col-span-6 xl:col-start-2">
              <CollapsibleTextSection
                title={title}
                text={subText}
                open={isOpen}
                dataTestId="CT-80-Author-Biography-Text"
              />
              {subText && (
                <div className="mt-7.5">
                  <LoadMoreButton
                    open={isOpen}
                    onClick={() => setIsOpen(!isOpen)}
                    loadMoreLabel={loadMoreLabel}
                    loadLessLabel={loadLessLabel}
                    dataTestId="CT-80-Author-Biography-Load-More"
                  />
                </div>
              )}
            </div>
          )}
        </div>
      </SoftLoadWrapper>
    </section>
  );
};

export default AuthorBiography;
